<template>
  <div>
    <div class="dashboard__overview-top">
      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          ₦ {{ new Intl.NumberFormat().format(totalUnpaidSettlementAmount) }}
        </p>
        <div class="dashboard__overview-booking-icon-wrap">
          <!-- <svgicon
            v-if="!summaryLoader"
            icon="listing_icon"
            class="dashboard__overview-booking-icon"
          ></svgicon> -->
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-booking-icon"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-if="summaryLoader"
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">Total unpaid settlement</p>
      </div>
      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          ₦ {{ new Intl.NumberFormat().format(totalPendingTransactionFee) }}
        </p>
        <div class="dashboard__overview-listing-icon-wrap">
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-listing-icon"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-if="summaryLoader"
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">
          Total pending transaction fee
        </p>
      </div>
      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          ₦ {{ new Intl.NumberFormat().format(flutterwaveWalletBalance) }}
        </p>
        <div class="dashboard__overview-earning-icon-wrap">
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-earning-icon"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-if="summaryLoader"
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">Flutterwave wallet balance</p>
      </div>

      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          ₦ {{ new Intl.NumberFormat().format(flutterwaveLedgerBalance) }}
        </p>
        <div class="dashboard__overview-active-icon-wrap">
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-active-icon"
            style="fill: #2e48da;stroke:transparent;"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-else
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">Flutterwave ledger balance</p>
      </div>
    </div>
    <div
      class="dashboard__payment-history-wrap dashboard__overview-table"
      v-if="settlements.length > 0"
    >
      <table class="dashboard__payment-history-table">
        <thead>
          <tr>
            <th class="dashboard__payment-history-table-heading">Host name</th>
            <th class="dashboard__payment-history-table-heading">Space name</th>

            <th class="dashboard__payment-history-table-heading">
              Settlement type
            </th>
            <th class="dashboard__payment-history-table-heading">
              Payment Gateway
            </th>
            <th class="dashboard__payment-history-table-heading">
              Amount
            </th>
            <th class="dashboard__payment-history-table-heading">
              Status
            </th>
            <th class="dashboard__payment-history-table-heading">
              Due date
            </th>
            <th class="dashboard__payment-history-table-heading">
              Date created
            </th>
            <th class="dashboard__payment-history-table-heading">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(settlement, index) in settlements"
            :key="index"
            class="dashboard__table-row"
          >
            <td class="dashboard__payment-history-table-data">
              {{ settlement.hostFullname | capitalize }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ settlement.spaceName | capitalize }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ settlement.settlementType | capitalize }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ settlement.paymentGateway | capitalize }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ settlement.currency === "GHS" ? "¢" : "₦" }}
              {{ new Intl.NumberFormat().format(settlement.amount) }}
            </td>
            <td class="dashboard__payment-history-table-data">
              <span
                class="dashboard__payment-history-table-status"
                :class="[
                  { pending: settlement.paymentStatus == 'unpaid' },
                  { approve: settlement.paymentStatus == 'paid' }
                ]"
                >{{ settlement.paymentStatus | capitalize }}</span
              >
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ formatDate(settlement.dueDate) }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ formatDate(settlement.created_at) }}
            </td>
            <td
              class="dashboard__payment-history-table-data dashboard__listing-table"
              v-if="settlement.paymentStatus == 'unpaid'"
            >
              <span
                class="maintenance__table-action"
                @click="togglePaidWarning(settlement.id)"
                >Mark as paid</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dashboard__pagination">
      <b-pagination
        v-if="settlements.length > 0"
        pills
        v-model="page"
        :total-rows="count"
        :per-page="pageSize"
        prev-text="Prev"
        next-text="Next"
        first-number
        last-number
        @change="handlePagination"
      ></b-pagination>
    </div>
    <div class="dashboard__empty" v-if="settlements.length === 0">
      <div class="dashboard__booking-empty">
        <img
          src="../../assets/illustrations/noBookings.svg"
          alt=""
          class="img-fluid"
        />
      </div>
      <p class="dashboard__booking-empty-text">
        You have no settlement yet.
      </p>
    </div>

    <AppModal :show="showPaidWarning" @onclosed="togglePaidWarning">
      <p class="warning__text">
        By marking this settlement as paid, it's assumed the host has been paid
        manually and won't be paid by the platform.
      </p>
      <div class="bedroom__preview-action">
        <button class="warning__cancel" @click="togglePaidWarning">
          Cancel
        </button>
        <button class="warning__delete" @click="markSettlementPaid">
          <svgicon
            v-if="paidLoader"
            icon="spinner"
            class="loading"
            style="fill: #FF4242;width: 20px;height: 20px;"
          ></svgicon>
          Mark as paid
        </button>
      </div>
    </AppModal>
    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import {
  getSettlement,
  getSettlementSummary,
  markSettlementPaid
} from "../../../services/invoice";
import { formatReadbleDate } from "../../utils";
export default {
  name: "settlement",
  components: {
    loader
  },
  data: () => {
    return {
      settlements: [],
      summaryLoader: false,
      loader: false,
      pageSize: 20,
      count: 0,
      page: 1,
      totalUnpaidSettlementAmount: 0,
      flutterwaveWalletBalance: 0,
      flutterwaveLedgerBalance: 0,
      totalPendingTransactionFee: 0,
      showPaidWarning: false,
      id: null,
      paidLoader: false
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page || 1;
      this.getSettlement();
    }
  },
  methods: {
    togglePaidWarning(id) {
      this.id = id;
      this.showPaidWarning = !this.showPaidWarning;
    },
    getSettlementSummary() {
      this.summaryLoader = true;
      getSettlementSummary()
        .then(res => {
          this.totalUnpaidSettlementAmount =
            res.data.totalUnpaidHostSettlementAmount;
          this.flutterwaveWalletBalance =
            res.data.flutterwaveNairaWalletBalance;
          this.totalPendingTransactionFee = res.data.totalPendingTransactionFee;
          this.flutterwaveLedgerBalance = res.data.flutterwaveLedgerBalance;
          this.summaryLoader = false;
        })
        .catch(err => {
          this.summaryLoader = false;
          return err;
        });
    },
    markSettlementPaid() {
      this.paidLoader = true;
      markSettlementPaid(this.id)
        .then(res => {
          this.paidLoader = false;
          this.showPaidWarning = false;
          this.id = null;
          this.showPaidWarning = !this.showPaidWarning;
          this.$notification.success({
            message: "Marked as paid successfully"
          });
          this.getSettlementSummary();
          this.getSettlement();
        })
        .catch(err => {
          this.paidLoader = false;
          this.showPaidWarning = !this.showPaidWarning;
          this.$notification.error({
            message: "Marked as paid failed",
            description: err.response.data.message
          });
          return err;
        });
    },
    async getSettlement() {
      this.loader = true;
      const data = await getSettlement(this.page, this.pageSize);
      try {
        this.settlements = data.data.settlementData;
        this.count = data.data.totalSettlementData;
        this.loader = false;
      } catch (err) {
        this.loader = false;
        return err;
      }
    },
    handlePagination(value) {
      this.page = value;
      this.$router.push({ query: { page: this.page } });
    },
    formatDate(date) {
      return formatReadbleDate(date);
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  async mounted() {
    this.page = this.$route.query.page || 1;
    await Promise.all([this.getSettlementSummary(), this.getSettlement()]);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/settlement.vue